import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FormControl, FormErrorMessage, FormHelperText, FormLabel, forwardRef, Input as ChakraInput, InputGroup, InputLeftAddon, InputLeftElement, InputRightElement, } from "@chakra-ui/react";
import { Info } from "@airhelp/icons";
import { useMobileDetect } from "@airhelp/use-mobile-detect";
export const ErrorIconColor = {
    danger: "danger.700",
    dangerHovered: "danger.800",
    warning: "warning.600",
    warningHovered: "warning.700",
};
export const defaultErrorIconColor = (colorScheme) => colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger;
export const defaultHoverErrorIconColor = (colorScheme) => colorScheme === "warning" ? ErrorIconColor.warningHovered : ErrorIconColor.dangerHovered;
export const Input = forwardRef(({ icon, label, errorMessage, placeholder, caption, isDisabled, isInvalid, isDouble, colorScheme = "error", iconPlacement = "left", leftAddonText, ...props }, ref) => {
    const isLeftSideIcon = icon && iconPlacement === "left";
    const isRightSideIcon = icon && iconPlacement === "right";
    const [iconColor, setIconColor] = useState("greyscale.500");
    const [errorIconColor, setErrorIconColor] = useState(defaultErrorIconColor(colorScheme));
    const [isInputFocused, setIsInputFocused] = useState(false);
    const isMobile = useMobileDetect();
    const hoveredErrorIconColor = () => isMobile ? defaultErrorIconColor(colorScheme) : defaultHoverErrorIconColor(colorScheme);
    const onFocus = () => {
        setIconColor("primary.500");
        setErrorIconColor("transparent");
        setIsInputFocused(true);
    };
    const onBlur = () => {
        setIconColor("greyscale.500");
        setErrorIconColor(defaultErrorIconColor(colorScheme));
        setIsInputFocused(false);
    };
    const onMouseOver = () => {
        if (!isInputFocused)
            setErrorIconColor(hoveredErrorIconColor());
    };
    const onMouseOut = () => {
        if (!isInputFocused)
            setErrorIconColor(defaultErrorIconColor(colorScheme));
    };
    useEffect(() => {
        setErrorIconColor(defaultErrorIconColor(colorScheme));
    }, [colorScheme]);
    return (_jsxs(FormControl, { alignItems: "start", isInvalid: isInvalid, children: [_jsx(FormLabel, { fontWeight: "bold", children: label }), isDouble ? (_jsxs(InputGroup, { children: [_jsx(InputLeftAddon, { display: "flex", justifyContent: "center", children: leftAddonText }), _jsx(ChakraInput, { placeholder: placeholder, isInvalid: isInvalid, isDisabled: isDisabled, colorScheme: colorScheme, maxW: "68px", ...props })] })) : (_jsxs(InputGroup, { color: iconColor, onFocus: onFocus, onBlur: onBlur, onMouseOver: onMouseOver, onMouseOut: onMouseOut, children: [_jsx(ChakraInput, { placeholder: placeholder, isDisabled: isDisabled, colorScheme: colorScheme, ref: ref, ...props }), isRightSideIcon && !isInvalid ? _jsx(InputRightElement, { pointerEvents: "none", children: icon }) : null, isLeftSideIcon ? _jsx(InputLeftElement, { pointerEvents: "none", children: icon }) : null, isInvalid && (_jsxs(InputRightElement, { pointerEvents: "none", right: isRightSideIcon ? 4 : 0, children: [_jsx(Info, { boxSize: 4, color: errorIconColor, mr: isRightSideIcon ? 1 : 0 }), isRightSideIcon ? icon : null] }))] })), !isInvalid
                ? caption && _jsx(FormHelperText, { children: caption })
                : errorMessage && _jsx(FormErrorMessage, { colorScheme: colorScheme, children: errorMessage })] }));
});
